// removed by extract-text-webpack-plugin
module.exports = {"scrollableItem":"scrollableItem___2xDav"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollableItem/index.scss
// module id = 104
// module chunks = 0